/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".timeline[_ngcontent-%COMP%]{position:relative;margin:60px 0 40px}.timeline__header[_ngcontent-%COMP%]{position:relative;height:36px;margin-bottom:20px;text-align:center}.timeline__content[_ngcontent-%COMP%]{position:relative}.timeline__cursor[_ngcontent-%COMP%]{position:absolute;top:0;left:50%;z-index:2;width:2px;height:100%;margin-left:-1px;background:#ffae00}.timeline__cursor[_ngcontent-%COMP%]:after, .timeline__cursor[_ngcontent-%COMP%]:before{content:'';position:absolute;left:-5px;border:10px solid transparent;border-right-width:6px;border-left-width:6px}.timeline__cursor[_ngcontent-%COMP%]:before{border-top-color:#ffae00;top:-8px}.timeline__cursor[_ngcontent-%COMP%]:after{border-bottom-color:#ffae00;bottom:-8px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline.component.styl.shim.ngstyle.js.pre-build-optimizer.js